import styled from 'styled-components'

interface IProps {
  isActive: boolean
}

export const Text = styled.span<IProps>`
  font-size: 14px;
  padding: 0 3px 0 3px;
  font-weight: ${props => (props.isActive ? 'bold' : 'normal')};
  color: ${props => (props.isActive ? props.theme.colors.color378ff7 : props.theme.colors.color6b7786)};
  cursor: pointer;
`
